export default __webpack_public_path__ + "static/media/kanye.82b37820.png";